"use strict";

module.exports = [
    "funding.service",
    "$stateParams",
    "notification.service",
    "$state",
    "July2024",
    "utilities.service",
    "October2025",
    function (fundingService, $stateParams, notification, $state, July2024, utilitiesService,October2025) {
        var vm = this;
        vm.yearAndMonth = +utilitiesService.convertMonthYearToYearMonth($stateParams.monthAndYear);
        vm.statement = $stateParams.statement;
        vm.july2024 = July2024;
        vm.october2025 = October2025;
    }
];
